import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import type { DndContainerProps } from './types'
import { DropTarget } from '../DropTarget'
import type { PropsWithChildren } from 'react'

export const DndContainer = (props: PropsWithChildren<DndContainerProps>) => {
  const { onDrop, children } = props

  return (
    <DndProvider backend={HTML5Backend}>
      <DropTarget onDrop={onDrop}>{children}</DropTarget>
    </DndProvider>
  )
}
